module.exports = __webpack_public_path__ + "static/img/pic-faq3.c3f466a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-faq3.png
// module id = 960
// module chunks = 0